import { useState, useEffect, useRef } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const bannerRef = useRef(null);

  const [preferences, setPreferences] = useState({
    necessary: true,
    personalization: true,
    marketing: true,
  });

  useEffect(() => {
    const consent = localStorage.getItem('padova-cookie-consent');
    if (consent) {
      const parsed = JSON.parse(consent);
      setPreferences(parsed);
      pushToGTM(parsed);
    } else {
      setIsVisible(true);
    }
  }, []);

  const pushToGTM = (prefs) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'cookie_consent_update',
      'consent_essential': prefs.essential,
      'consent_personalization': prefs.personalization,
      'consent_marketing': prefs.marketing,
    })
  }

  useEffect(() => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (isSettingsOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      if (bannerRef.current) {
        bannerRef.current.style.paddingRight = `${scrollbarWidth}px`;
      }
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '0px';
      if (bannerRef.current) {
        bannerRef.current.style.paddingRight = '0px';
      }
    }
  }, [isSettingsOpen]);

  const handleBack = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsSettingsOpen(false);
      setIsClosing(false);
    }, 500);
  };

  const handleSave = (all = false) => {
    const newPrefs = all ? { essential: true, personalization: true, marketing: true } : preferences;
    localStorage.setItem('padova-cookie-consent', JSON.stringify(newPrefs));
    setPreferences(newPrefs);
    pushToGTM(newPrefs);
    setIsVisible(false);
    document.body.style.overflow = '';
    document.body.style.paddingRight = '0px';
  }

  if (!isVisible) return null;

  return (
    <>
      <div className="padova-banner-fixed" ref={bannerRef}>
        <div className="padova-container">
          <div className="padova-text">
            <h3>Configuración de Preferencias de Navegación</h3>
            <p>Al aceptar el uso de cookies, optimizamos tu interacción con nuestro sitio mediante una experiencia a medida. Ten en cuenta que restringir ciertos datos podría limitar las funciones y servicios disponibles.</p>
          </div>
          <div className="padova-btns">
            <button className="btn-pri" onClick={() => handleSave(true)}>Aceptar todas</button>
            <button className="btn-sec" onClick={() => setIsSettingsOpen(true)}>Personalizar</button>
          </div>
        </div>
      </div>

      {isSettingsOpen && (
        <div className={`padova-settings-overlay ${isClosing ? 'slide-down' : 'slide-up'}`}>
          <div className="settings-content">
            <header className="settings-header">
              <button className="btn-back" onClick={handleBack}>
                Cerrar
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#80B226" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"/></svg>
                </span>
              </button>
              <h2>Personalización de cookies</h2>
              <p>Si autorizas las cookies, nuestra web podrá almacenar o recuperar información que te permitirá tener una experiencia personalizada con nosotros. No autorizar algunos tipos de cookies puede afectar esta experiencia y los servicios que te podemos ofrecer. Este es el detalle:</p>
            </header>
            <div className="settings-body">
              <CookieItem
                title="Cookies de Personalización"
                desc="Analizamos tus intereses para ofrecerte contenido diseñado específicamente para ti."
                active={preferences.personalization}
                onToggle={() => setPreferences({...preferences, personalization: !preferences.personalization})}
              />
              <CookieItem 
                title="Cookies de Publicidad" 
                desc="Nos permiten mostrarte ofertas y productos alineados con tus hábitos de navegación." 
                active={preferences.marketing} 
                onToggle={() => setPreferences({...preferences, marketing: !preferences.marketing})} 
              />
              <CookieItem 
                title="Cookies Esenciales" 
                desc="Son fundamentales para la estabilidad del sitio y no pueden desactivarse." 
                active={true}
                disabled={true}
              />
            </div>
            <footer className="settings-footer">
              <button className="btn-pri-save" onClick={() => handleSave(false)}>Guardar configuración</button>
              <p>
                El uso de cookies no necesarias no condiciona la navegación en el sitio web ni la prestación de los servicios que nos solicites. En cualquier momento podrás ejercer tu derecho de desactivación o eliminación de las cookies no necesarias en la sección de Privacidad de tu navegador. Si lo autorizas, al tratamiento de la información que captemos le resultará aplicable nuestra <a href='https://padova.pe/assets/pdf/politicas-de-privacidad.pdf' target='_blank' rel='noreferrer'>Política de Privacidad</a>.
              </p>
            </footer>
          </div>
        </div>
      )}
    </>
  );
};

const CookieItem = ({ title, desc, active, onToggle, disabled }) => (
  <div className="c-item">
    <div className="c-info">
      <h4>{title}</h4>
      <p>{desc}</p>
    </div>
    {
      !disabled && (
        <label className="padova-tgl">
          <input type="checkbox" checked={active} onChange={onToggle} disabled={disabled} />
          <span className="padova-sld"></span>
        </label>
      )
    }
  </div>
);

export default CookieConsent;